module.exports = __webpack_public_path__ + "static/media/truck_canceled.6446977d.png";